import { TheWestSection } from '@news-mono/common'
import { metrics } from '@news-mono/component-library'
import { StaticRoute } from '@news-mono/web-common'
import { layout } from '../../App.routing'

export const createUnsubscribePage: StaticRoute<TheWestSection> = () => {
    return {
        kind: 'page',
        heading: 'Unsubscribe - Email Preferences',
        hideHeading: true,
        pageType: 'static',
        adTargeting: {
            pageId: 'email-preferences/unsubscribe',
            adUnitPath: '',
            ssAdUnits: [],
            topics: [],
        },
        section: 'default',
        compositions: [
            layout.composition({
                type: 'thor',
                props: {
                    containerWidth:
                        metrics.thewest.siteMetrics.mainContentWidth,
                    verticalGutters: true,
                    horizontalGutters: false,
                },
                contentAreas: {
                    main: [
                        layout.nestedComposition({
                            type: 'thor',
                            props: {
                                containerWidth: '100%',
                                horizontalGutters: true,
                                hasBackgroundFill: true,
                            },
                            contentAreas: {
                                main: [
                                    layout.component({
                                        type: 'email-preference-unsubscribe',
                                        props: {},
                                    }),
                                ],
                            },
                        }),
                    ],
                },
            }),
        ],
    }
}
